// extracted by mini-css-extract-plugin
export var mt0 = "quotes-module--mt-0--3dd18";
export var mt1 = "quotes-module--mt-1--bd92a";
export var mt2 = "quotes-module--mt-2--f22da";
export var mt3 = "quotes-module--mt-3--27a9a";
export var mt4 = "quotes-module--mt-4--a4e78";
export var mt5 = "quotes-module--mt-5--1ba84";
export var mt6 = "quotes-module--mt-6--5d032";
export var quotes = "quotes-module--quotes--8e02c";
export var quotesDark = "quotes-module--quotes--dark--54723";
export var quotesFormLayout = "quotes-module--quotes--form-layout--4648b";
export var quotes__pager = "quotes-module--quotes__pager--057cd";
export var quotes__pagerButton = "quotes-module--quotes__pager-button--69b29";
export var quotes__pagerButtonActive = "quotes-module--quotes__pager-button--active--589cb";
export var quotes__pagerItem = "quotes-module--quotes__pager-item--cf13c";
export var quotes__slide = "quotes-module--quotes__slide--c1566";
export var quotes__slideActive = "quotes-module--quotes__slide--active--4bf70";
export var quotes__slides = "quotes-module--quotes__slides--91853";
export var quotes__viewport = "quotes-module--quotes__viewport--a9438";